import React, {createRef, useEffect, useState} from 'react'
import { useScreenshot } from 'use-react-screenshot'
import "./vc.css"
import screenshot from "../../assets/img/screenshot.png"
import Api from "../../utils/api";
import {useParams} from "react-router";
import {toast} from "react-toastify";
import {Loading} from "../../components";
import html2canvas from 'html2canvas';

const Vc = () => {
    const ref = createRef(null)
    const [image, takeScreenshot] = useScreenshot()
    const [loading , setLoading] = useState(false)
    const [link , setLink] = useState("")

    let param = useParams()

    useEffect(() => {
        new Api().get(`/backend/insurance/damage/video-call/get-link/${param.id}/${param.uid}`)
            .then((res) => {
                setLink(res.link)
            })
            .catch((err) => {
                setLoading(false)
            })
    } ,[])



    const getImage = () => {
        setTimeout(() => {
            html2canvas(ref.current.querySelector('iframe'), { useCORS: true })
                .then((canvas) => {
                    const dataUrl = canvas.toDataURL('image/png');
                    console.log(dataUrl);

                    let obj = {
                        encrypt: true,
                        file: dataUrl,
                        base64: "true",
                        directory: screenshot,
                        damage_id: param.id,
                    };

                    setLoading(true);

                    new Api()
                        .post(`/backend/fileManager/attachment`, obj, false)
                        .then((res) => {
                            setLoading(false);
                            toast.success(res.msg);
                        })
                        .catch((err) => {
                            setLoading(false);
                        });
                })
                .catch((error) => {
                    console.error(error);
                });
        }, 1000); // تاخیر 1 ثانیه
    };



    return (
        <>
            <div ref={ref}>
                <div className={"vc"}>
                    <iframe src={link}/>
                </div>
            </div>
            <div>
                <div className={"screenShotBtn"} onClick={getImage}>
                    {
                        loading ? <Loading/> :
                            <img src={screenshot} title={"اسکرین شات"}/>

                    }
                </div>
            </div>
        </>

    );
};

export default Vc;
